export default [
  {
    path: "supply/performance-attribution",
    name: "SupplyPerformanceAttribution",
    component: () => import("../pages/supply/PerformanceAttribution.vue"),
    meta: {
      title: "业绩归属市场",
    },
  },
  {
    path: "supply/companyList",
    name: "SupplyCompanyList",
    component: () => import("../pages/supply/CompanyList.vue"),
    meta: {
      title: "商家公司列表",
    },
  },

  {
    path: "supply/companyEdit/:company_id",
    name: "SupplyCompanyEdit",
    component: () => import("../pages/supply/CompanyEdit.vue"),
    meta: {
      title: "新建/编辑商家公司",
    },
  },
  {
    path: "supply/rebate",
    name: "SupplyRebate",
    component: () => import("../pages/supply/Rebate.vue"),
    meta: {
      title: "让利销售汇总表",
    },
  },
  {
    path: "supply/third-delivery-record",
    name: "ThirdDeliveryRecord",
    component: () => import("../pages/supply/ThirdDeliveryRecord.vue"),
    meta: {
      title: "第三方系统发货与代采单信息关联记录",
    },
  },
  {
    path: "supply/performan-config", // 履约指标配置
    name: "SupplyPerformanConfig",
    component: () =>
      import("@/pages/supply/PerformanceIndicatorConfig/index.vue"),
    meta: {
      title: "履约指标配置",
    },
  },
  {
    path: "supply/settled-in", // 商家重启申请列表
    name: "SupplySettledIn",
    component: () => import("@/pages/supply/SupplySettledIn.vue"),
    meta: {
      title: "商家重启申请列表",
    },
  },
];
// reCommodityRouter;



// WEBPACK FOOTER //
// ./src/router/supply.js